import React, { useContext } from 'react';
import Button from '../../../components/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '../../../components/Link';
import LockIcon from '@material-ui/icons/Lock';
import Select from '../../../components/engine/SelectEngine';
import styled from 'styled-components/macro';
import { TextString } from '../../../components/Text';
import useTranslations from '../../../hooks/useTranslations';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import Divider from '@material-ui/core/Divider';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';
import _BackButton from '../../../components/BackButton';
import { FormBuilderIntegrationsContext } from '../engine/FormBuilderIntegrationsEngine';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ConnectButton = styled(Button)`
  width: 40em;
  align-self: center;
`;

const ConnectedDiv = styled.div`
  width: 40em;
  align-self: center;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`;

const SecureContainer = styled.small`
  font-style: italic !important;
  text-align: center;
  margin-top: 0.4rem;
`;

const StyledLock = styled(LockIcon)`
  font-size: 16px !important;
  position: relative;
  top: 2px;
`;

const H2 = styled.h2`
  margin: 1.2rem 0 0.8rem;
  font-size: 18px;
`;

const SaveButtonContainer = styled.div`
  margin-top: 1rem;
  text-align: right;
`;

const SubText = styled.p``;

const BackButton = styled(_BackButton)`
  && {
    align-self: baseline;
  }
`;

const CheckboxContainer = styled.div`
  position: relative;
  top: -10px;
`;

const StyledCheckbox = styled(Checkbox)`
  && svg {
    font-size: 18px !important;
  }
`;

const TemplateSelectContainer = styled.div`
  position: relative;
`;

const TemplateLink = styled(Link)`
  position: absolute;
  left: 16rem;
  top: 26px;
`;

const FormBuilderDocusignView = props => {
  const t = useTranslations();
  const { setCurrentIntegrationPage } = useContext(
    FormBuilderIntegrationsContext
  );
  return (
    <>
      <Container>
        <SimpleFlexContainer>
          <BackButton onClick={() => setCurrentIntegrationPage('')} />
          <ButtonContainer>
            {props.docusignConnected ? (
            <ConnectedDiv>
              {t('form-builder.integrations.docusign.sign_success')}
            </ConnectedDiv>
            ) : (
            <ConnectButton
              onClick={props.clickedSign}
            >
              {t('form-builder.integrations.docusign.sign')}
            </ConnectButton>
            )}
            <SecureContainer>
              <StyledLock /> {t('form-builder.integrations.docusign.secure')}
            </SecureContainer>
          </ButtonContainer>

          <H2>{t('form-builder.integrations.docusign.trigger_title')}</H2>
          <SubText>
            {t('form-builder.integrations.docusign.trigger_text')}
          </SubText>
          <Divider />

          <H2>{t('form-builder.integrations.docusign.template_title')}</H2>
          <SubText>
            {t('form-builder.integrations.docusign.template_text')}
          </SubText>
          <TemplateSelectContainer>
            <Select
              // variant="contained"
              disabled={!props.docusignConnected}
              onChange={value => props.setDropdownValue(value)}
              value={props.dropdownValue}
              label="exportDialog.select"
              options={props.dropdownOptions}
              customCSS="margin-bottom: 1.2rem !important;"
            />
            <TemplateLink to={`/report-builder/new-single/${props.formId}/docusign`} data-testid="create-new-template" content='exportDialog.create' />
          </TemplateSelectContainer>

          <CheckboxContainer>
            <FormControlLabel
              control={
                <StyledCheckbox
                  color="primary"
                  disabled={!props.docusignConnected}
                  checked={props.includeBlanks}
                  onChange={e => props.setIncludeBlanks(e.target.checked)}
                />
              }
              label={
                <small>
                  <TextString content="exportDialog.include" />
                </small>
              }
            />
            <FormControlLabel
              control={
                <StyledCheckbox
                  color="primary"
                  disabled={!props.docusignConnected}
                  checked={props.includeLogo}
                  onChange={e => props.setIncludeLogo(e.target.checked)}
                />
              }
              label={
                <small>
                  <TextString content="exportDialog.include_logo" />
                </small>
              }
            />
          </CheckboxContainer>
          <Divider />

          <SaveButtonContainer>
            {props.docusignConnected && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={props.clickedDisconnect}
              >
                {t('form-builder.integrations.docusign.disconnect')}
              </Button>
            )}
          </SaveButtonContainer>
        </SimpleFlexContainer>
      </Container>
    </>
  );
};

export default FormBuilderDocusignView;
